import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatAmount } from '../utils';

export default function AuthCarousel({ authCarouselItems = [] }) {
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    function handleNext() {
      if (slideIndex !== authCarouselItems.length - 1) {
        setSlideIndex(slideIndex + 1);
      } else {
        setSlideIndex(0);
      }
    }

    const interval = setInterval(() => {
      handleNext();
    }, 2000);

    return () => clearInterval(interval);
  });

  return (
    <div className='h-full w-full flex justify-center items-center'>
      {authCarouselItems.map(
        (item, index) =>
          item.advert_status.id === 1 && (
            <Link
              to={item.ads_link}
              target='_blank'
              className={`w-full relative left-0 isolate ${
                slideIndex === index
                  ? 'animate-[fade_1.5s_ease-in-out]'
                  : 'hidden'
              }`}
              key={index}
            >
              <div className='h-full'>
                {item.advert_format.id === 1 && (
                  <img
                    src={item.url}
                    alt=''
                    className='w-full h-full object-contain object-center'
                  />
                )}
                {item.advert_format.id === 2 && (
                  <iframe
                    src={item.url}
                    width='60%'
                    height='100%'
                    title='Video'
                  ></iframe>
                )}
              </div>
              <figcaption
                className={`bg-black/20 w-full h-full absolute left-0 top-0  rounded-xl  z-30 flex justify-center items-center flex-col`}
              >
                <h2 className='font-bold text-p-bk text-4xl'>{item.title}!</h2>
                {!!item.offers.length && (
                  <span>
                    <p className='text-p-bk text-6xl font-semibold'>
                      {formatAmount(item.offers[0]?.discount)}
                    </p>
                  </span>
                )}
              </figcaption>
            </Link>
          )
      )}
    </div>
  );
}
